import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import Logo from '../../core/components/Logo';
import { PreloadImage } from '../../pages/components';
import { ParallaxElement } from '../../parallax/components';

const HeaderParallaxWrap = styled.div`
  padding: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const HeaderParallaxElement = styled(ParallaxElement)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: auto;
    transform: translate(0%, -50%);
    top: 50%;
    position: absolute;
  }
`;

const ArticleHeader = styled.div`
  width: 100%;
  left: -${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  right: -${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  top: 0;
  padding-top: ${props =>
    props.breakpoint === 'phone' ? 88.8888888888889 : 44.8924731182796}%;
  padding-left: ${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  padding-right: ${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  position: relative;
  z-index: 0;
  color: ${styles.color.WHITE};
`;

const StyledLogo = styled(Logo)`
  position: absolute;
  //top: 2.8125rem;
  //top: 2.4375rem;
  //left: 1.875rem;
  top: 3.1875rem;
  left: 3.75rem;

  ${styles.media.tablet`
    top: 3.9375rem;
  `} ${styles.media.phone`
    top: 3.1875rem;
    left: 1.875rem;
  `} z-index: 1000;
`;

const ArticleHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: absolute;
  ${props =>
    props.breakpoint === 'phone'
      ? `padding: 0 2.5rem;`
      : props.isSubPage
        ? props.breakpoint === 'desktop'
          ? `padding: 5.625rem 13.125rem 5.625rem 15rem;`
          : `padding: 5.625rem 22.5rem 5.625rem 5.625rem;`
        : `padding: 5.625rem;`} top: 0;
  left: 0;
  right: ${props =>
    props.breakpoint === 'desktop'
      ? '50%'
      : props.breakpoint === 'tablet' ? 'calc(25% + 0.9375rem)' : '25%'};
  bottom: 0;
  align-items: flex-start;

  h3 {
    color: ${styles.color.ORANGE};
    font-family: 'ApercuMono';
    font-size: 1rem;
    text-transform: uppercase;
    flex-shrink: 0;
    margin: auto 0 1rem;
  }

  h1 {
    color: ${props =>
      props.isSubPage ? styles.color.CHARCOAL : styles.color.WHITE};
    flex-shrink: 0;
    margin: 0 0 1.5rem;
  }

  ${props =>
    props.breakpoint !== 'desktop' &&
    props.isSubPage &&
    `
    h1, h3 {
      padding: .5rem .75rem;
      background: white;
    }
    h3 {
      margin-bottom: 0;
    }
  `};
`;

const NarrowHeaderFigureWrap = styled.div`
  padding: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: calc(75% - 0.9375rem);
`;

const PageHeader = props => {
  const { title, subtitle, mainImage, subpage, breakpoint } = props;
  return (
    <ArticleHeader breakpoint={breakpoint}>
      <StyledLogo theme={subpage ? 'dark' : 'light'} />
      {!subpage ? (
        <HeaderParallaxWrap>
          <HeaderParallaxElement depth={-10} topAlign>
            <PreloadImage src={mainImage} background />
          </HeaderParallaxElement>
        </HeaderParallaxWrap>
      ) : (
        <NarrowHeaderFigureWrap>
          <HeaderParallaxElement depth={-10} topAlign>
            <PreloadImage src={mainImage} background />
          </HeaderParallaxElement>
        </NarrowHeaderFigureWrap>
      )}
      <ArticleHeaderContent isSubPage={subpage} breakpoint={breakpoint}>
        <h3>{subtitle}</h3>
        <h1>{title}</h1>
      </ArticleHeaderContent>
    </ArticleHeader>
  );
};

PageHeader.propTypes = {
  breakpoint: PropTypes.string,
  subpage: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  mainImage: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(PageHeader);



// WEBPACK FOOTER //
// ./src/modules/content/components/PageHeader.js